import { FC, PropsWithChildren } from "react";
import { ComponentWrapperProps } from "/Models/Generated/ComponentWrapperProps";
import * as Components from "/App.Components";

const ComponentWrapper: FC<PropsWithChildren<ComponentWrapperProps>> = ({
  name,
  component,
}: ComponentWrapperProps) => {
  const Comp = (Components as { [index: string]: any })[name ?? ""];

  if (!Comp || !component) {
    return null;
  }

  return <Comp {...component} />;
};

export default ComponentWrapper;
